import React from 'react';
import { Element } from '../types';

interface ElementSidePanelProps {
  isOpen: boolean;
  element: Element;
  onClose: () => void;
  onUpdate: (element: Element) => void;
}

const ElementSidePanel: React.FC<ElementSidePanelProps> = ({
  isOpen,
  element,
  onClose,
  onUpdate
}) => {
  if (!isOpen) return null;

  return (
    <div className="side-panel-overlay">
      <div className="side-panel">
        <div className="side-panel-header">
          <h3>Edit {element.name}</h3>
          <button className="side-panel-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="side-panel-content">
          <p>Element side panel functionality coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default ElementSidePanel; 